import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`

export const HeroImage = styled.figure`
  img {
    max-width: 100%;
    height: auto;
  }
`

export const Section = styled.div`
  padding: 0 24px;
`

export const AdvantagesList = styled.div`
  display: flex;
  flex-direction: column;
  margin: 24px 0 32px;
  gap: 16px;

  span {
    flex: 1;
  }
`

export const Advantages = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`
export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: auto;
  padding: 0 24px 24px;

  > div {
    margin-bottom: 16px;
  }
`
